import Color from "color";

// algorithm copied from https://filosophy.org/code/online-tool-to-lighten-color-without-alpha-channel/
export default function createOrgPrimaryLightColor(primaryColor: string) {
  const color = Color(primaryColor).rgb();
  const white = Color("#fff").rgb();

  const opacity = 0.2;

  return Color.rgb(
    opacity * color.red() + (1 - opacity) * white.red(),
    opacity * color.green() + (1 - opacity) * white.green(),
    opacity * color.blue() + (1 - opacity) * white.blue()
  ).hex();
}
